<template>
  <div style="width: 100%">
    <div class="k-row">
    <div :class="textColor" class="k-participant-icons">
      <div class="d-flex">
        <font-awesome-icon
          class="mb-1 user-circle"
          color=""
          v-if="participant.user_id"
          :icon="['fas', 'user-circle']"
        />
      </div>
      <div class="d-flex" v-if="isInvited(participant)">
        <font-awesome-icon
          class="pb-0 user-circle"
          size="xs"
          color=""
          :icon="['fal', 'envelope-open']"
          v-if="isInvitationVisited"
        />
        <font-awesome-icon
          v-else
          class="pb-0 user-circle"
          size="xs"
          color=""
          :icon="['fal', 'envelope']"
        />
      </div>
    </div>
    <div
      class="k-participant-details justify-content-start align-items-center py-1"
      :class="participantClasses"
      :title="tooltip"
    >
      <div class="k-participant-name text-standard">
        {{ participant.name }}
      </div>
      <div
        class="k-participant-email text-very-small text-weight-light"
        v-if="isEmailVisible"
      >
        <div v-if="participantEmail" class="k-email">
          {{ participantEmail }}
        </div>
      </div>
    </div>
    <div
      v-if="isEditable"
      class="k-participant-end"
      :class="[isDarkMode ? 'dark-mode-edit-color' : 'regular-mode-edit-color']"
    >
      <font-awesome-icon class="pb-0" size="xs" :icon="['fal', 'pencil']" />
    </div>
    </div>
    <div v-if="isCurrentUser" :class="currentUserCustomClass">
      {{ $t(notificationMessage) }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { themeMixin } from '../mixins/ThemeMixins';
import shared from '@/shared.js';

export default {
  name: 'RenderParticipant',
  mixins: [themeMixin],
  data() {
    return {
      notificationMessage: "",
      currentUserCustomClass: "",
    }
  },
  props: [
    'isOwner',
    'isEditable',
    'tooltip',
    'isEmailVisible',
    'participant',
    'isCurrentUser',
  ],

  computed: {
    ...mapGetters(['isDarkMode']),

    participantEmail() {
      if (!this.isEmailVisible) return null;

      if (this.participant.invitation != null) {
        return this.participant.invitation.email;
      }
      if (this.participant.user != null) {
        return this.participant.user.email;
      }
      return null;
    },
    participantClasses() {
      let classes = '';
      if (this.isCurrentUser) {
        classes += ' is-current-user';
      }
      console.log(
        'participantClasses:',
        this.participant.name,
        this.participant.isCurrentUser,
        classes
      );
      return classes;
    },

    isInvitationVisited() {
      return (this.participant.invitation && this.participant.invitation.visited);
    }
  },

  methods: {
    isInvited(participant) {
      if (!this.isOwner) return false;
      if (participant.invitation_id == null) return false;
      return true;
    },
    initials(name) {
      if (!name) {
        return ' ';
      }
      // join all the charcter after the space and took maximum 2 character
      return shared.getInitials(name);
    },
    compareChoices() {
      this.notificationMessage = "";
      this.currentUserCustomClass = "current-user-notification";
      //console.error("Render Participant compareChoices:", this.participant);
      if(this.participant) {
        if(this.participant.choice == -1) {
          this.notificationMessage = "options.noAnswerSubmitted2";
          this.currentUserCustomClass += " notification-red-bar"
        } else {
          this.notificationMessage = "options.allAnswerSubmitted2";
          this.currentUserCustomClass += " notification-green-bar"
        }
      }
    }
  },

  mounted() {
    this.compareChoices();
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/style.scss';
.k-participant-details {
  flex-shrink: 1;
  flex-direction: column;
  flex-grow: 1;
  width: 70%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.k-email {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}

.k-participant-name {
  // line-height: 30px;
}

.k-participant-icon {
  // display: contents;
}

.user-circle {
}

.notification-red-bar {
  //background-color: $primary;
  color: $primary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-green-bar {
  //background-color: $secondary;
  color: $checked-color;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.current-user-notification {
  font-size: $very-small;
  font-weight: $medium-weight;
  text-align: center;
  margin: 2px;
  border-radius: 3px;

}

@media screen and (max-width: 480px) {
  .k-participant-name {
    line-height: 20px;
  }
  .current-user-notification {
    font-size: $standard;
  }
}
</style>
